"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This function can be used to sleep the function execution flow for given milliSeconds
 * @param milliSeconds
 */
function sleep(milliSeconds) {
    return new Promise(function (resolve) { return setTimeout(resolve, milliSeconds); });
}
exports.sleep = sleep;
